// Common
import React from 'react';

// YMAPS
import { YMaps, Map } from 'react-yandex-maps';

class MAP extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      center: [55.753215, 37.622504],
      ymaps: false,
      map: false,
    };
  }

  init_map(ref) {
    ref && ref.geoObjects.removeAll();
    if (this.props.data.type === 'route') {
      let multiRoute = new this.state.ymaps.multiRouter.MultiRoute(
        {
          referencePoints: this.props.data.markers,
          params: {
            results: 1,
          },
        },
        {
          boundsAutoApply: this.props.data.markers.length > 1 ? true : false,
        }
      );
      ref && ref.geoObjects.add(multiRoute);
    } else {
      let geoObjects = [],
        clusterer = new this.state.ymaps.Clusterer({
          groupByCoordinates: false,
          clusterDisableClickZoom: true,
          clusterHideIconOnBalloonOpen: false,
          geoObjectHideIconOnBalloonOpen: false,
        });
      for (var i = 0, len = this.props.data.markers.length; i < len; i++) {
        this.state.ymaps
          .geocode(this.props.data.markers[i], {
            results: 1,
          })
          .then(function(res) {
            var firstGeoObject = res.geoObjects.get(0);
            geoObjects.push(firstGeoObject);
            clusterer.add(geoObjects);
            ref.geoObjects.add(clusterer);
            ref.setBounds(clusterer.getBounds(), {
              checkZoomRange: true,
            });
          });
      }
    }
    if (this.props.data.markers.length === 1) {
      this.state.ymaps
        .geocode(this.props.data.markers[0], {
          results: 1,
        })
        .then(function(res) {
          var firstGeoObject = res.geoObjects.get(0),
            bounds = firstGeoObject.properties.get('boundedBy');
          ref.setBounds(bounds, {
            checkZoomRange: true,
          });
        });
    }
    if (!this.state.map) {
      this.setState((state, props) => ({
        map: ref,
      }));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      this.init_map(this.state.map);
    }
  }

  init_ymaps(ymaps) {
    console.log(ymaps);
    this.setState((state, props) => ({
      ymaps: ymaps,
    }));
  }

  render() {
    return (
      <YMaps
        query={{
          apikey: 'b6a66b8f-dc2c-4946-a916-0fb0ca680e5a',
        }}
        onApiAvaliable={ymaps => this.init_ymaps(ymaps)}
      >
        <Map
          state={{
            center: this.state.center,
            zoom: 10,
            controls: [],
          }}
          instanceRef={ref => this.init_map(ref)}
          width={'100%'}
          height={510}
        ></Map>
      </YMaps>
    );
  }
}

export default MAP;
